import { Mic } from 'lucide-react';

interface VoiceButtonProps {
    onClick?: () => void;
}

export default function VoiceButton({ onClick }: VoiceButtonProps) {
    return (
        <button
            onClick={onClick}
            className="w-14 h-14 bg-[#0D5F6B] rounded-full flex items-center justify-center shadow-[0_12px_32px_rgba(13,95,107,0.12),0_6px_12px_rgba(13,95,107,0.08)] active:shadow-[0_8px_24px_rgba(13,95,107,0.10),0_4px_8px_rgba(13,95,107,0.06)] transition-shadow"
            aria-label="Voice capture"
        >
            <div className="w-6 h-6 flex items-center justify-center">
                <Mic className="w-5 h-5 text-white" />
            </div>
        </button>
    );
}
